 export const hexToRgb = (hex) => {
    hex = hex.replace('#', '');
    const bigint = parseInt(hex, 16);
    return [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255];
  };



   export const groupByEColumn = (data) => {
    const groups = {};
    let currentE = '';
    data.forEach((row) => {
      const eVal = row[4]?.toString().trim() || currentE;
      if (eVal !== '') currentE = eVal;
      if (!groups[currentE]) groups[currentE] = [];
      groups[currentE].push(row);
    });
    return groups;
  };



  export const getOrdinalSuffix = (numStr) => {
    const num = parseInt(numStr);
    if (isNaN(num)) return null;
    const lastDigit = num % 10;
    const lastTwo = num % 100;
    let suffix = 'th';
    if (lastTwo < 11 || lastTwo > 13) {
      if (lastDigit === 1) suffix = 'st';
      else if (lastDigit === 2) suffix = 'nd';
      else if (lastDigit === 3) suffix = 'rd';
    }
    return { number: num, suffix };
  };